export const markdownTextStyles = {
  root: "aui-md prose prose-sm max-w-none break-words",
};
